module.exports = __webpack_public_path__ + "img/admin-2016-recruit.79f8491d.jpg";